import state from "./state"

export const user = state => state.user
export const storage = state => state.storage
export const breadcrumbData = state => state.breadcrumbData
export const menu = state => state.menu
export const currentMenuId = state => state.currentMenuId
export const permissions = state => state.permissions
export const unreadNumber = state => state.unreadNumber
export const showLeftMenu = state => state.showLeftMenu
export const routerSelect = state => state.routerSelect
export const windowScale = state => state.windowScale